/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'fabric.linkPicker.button.cancel': 'Avbryt',
  'fabric.linkPicker.button.insert': 'Sett inn',
  'fabric.linkPicker.button.save': 'Lagre',
  'fabric.linkPicker.clearLink': 'Tøm',
  'fabric.linkPicker.clearLinkText': 'Fjern tekst',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {finner ingen resultater} one {finner {count,number} resultat} other {finner {count,number} resultater}}',
  'fabric.linkPicker.linkAriaLabel': 'Skriv eller lim inn en kobling i feltet',
  'fabric.linkPicker.linkHelperTextAriaLabel': 'Hjelpetekst for koblingsvisning',
  'fabric.linkPicker.linkHelperTextLabel': 'Gi denne koblingen en tittel eller beskrivelse',
  'fabric.linkPicker.linkInvalid': 'Oppgi en gyldig nettadresse.',
  'fabric.linkPicker.linkLabel': 'Kobling',
  'fabric.linkPicker.linkPlaceholder': 'Lim inn en kobling',
  'fabric.linkPicker.linkTextAriaLabel': 'Koblingstekst',
  'fabric.linkPicker.linkTextLabel': 'Visningstekst (valgfritt)',
  'fabric.linkPicker.linkTextPlaceholder': 'Tekst som skal vises',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Nylig vist',
  'fabric.linkPicker.listTitle.results': 'Resultater',
  'fabric.linkPicker.search.error.description': 'Oppdater siden, eller kontakt <a>Atlassian-støtte</a> hvis dette fortsetter å skje.',
  'fabric.linkPicker.search.error.heading': 'Vi har problemer med å laste inn dataene.',
  'fabric.linkPicker.search.error.retry': 'Oppdater',
  'fabric.linkPicker.search.linkAriaLabel': 'Forslag vises nedenfor etter hvert som du skriver inn i feltet',
  'fabric.linkPicker.search.linkLabel': 'Søk etter eller lim inn en kobling',
  'fabric.linkPicker.search.linkPlaceholder': 'Finn nylige koblinger eller lim inn en ny kobling',
  'fabric.linkPicker.search.noResults.description': 'Prøv igjen med et annet begrep.',
  'fabric.linkPicker.search.noResults.heading': 'Vi finner ikke noe som samsvarer med søket ditt.',
  'fabric.linkPicker.status.submitting': 'Sender inn',
  'fabric.linkPicker.time.message.updated': 'Oppdatert {time}',
  'fabric.linkPicker.time.message.viewed': 'Vist {time}',
  'fabric.linkPicker.unhandledError.description': 'Prøv å laste inn siden på nytt.',
  'fabric.linkPicker.unhandledError.heading': 'Noe gikk galt!'
};